import React,{useState} from "react";
import {Grid, Box, styled, Card, Avatar, Button, Typography, TextField, CircularProgress} from '@mui/material';
import {InputBox, Label, Logo,CustemBtn} from '../../components/Custom';
import { useNavigate, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import  validate  from "../../validation/validation";
import DisplayError from "../../validation/DisplayError";
import {LoginContainer, LogoBox, ForgotPasswordDetails} from './Authorization.style'
import SignInImage from "../../asserts/LoginImage.jpg";
import { H1FormTitle, H5FormLabel, H7TablePrimeContent } from "../../theme/Theme";
import LessThanIcon from "../../components/Icons/LessThanIcon";
import image from "../../asserts/LALogistic-1.png";
import ThemeColor from "../../theme/ThemeColor";
import { emailSend } from "../../redux/Thunk/authThunk";
import Swal from "sweetalert2";

const ForgotPassword = () =>{
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [Email, setEmail] = useState('');
  const [error,setError] = useState([]);
  const [displayErrorMsg, setDisplayErrorMsg] = useState("");
  const [loader, setLoader] = useState(false)

  let validation_input = [
    {tagid: 'email', text: Email, regex_name: 'email', required: true, errmsg: 'Please enter registered email.'}]
   
  const handleChangeForEmail = (event) => {
    setEmail(event.target.value.trim())
  }
 
  // Write function of create otp using email id
  const submitRegisteredEmailAddress = () =>{
    if(validate(validation_input).length == 0){
      setLoader(true)
      dispatch(emailSend({Email : Email})).then((data)=>{
        if(data?.payload?.success === true){
          setLoader(false)
          Swal.fire({
            title: 'Your request to reset password is granted.',
            text: 'Kindly check your registered email to reset your password.',
            icon: 'info',
            showCancelButton: false,
            confirmButtonText: 'Okay',
            customClass: {
              popup: 'custom-modal',
              confirmButton: 'popup-blueOne',
            },
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              navigate('/sendotp', { state: { sendDetails: { Email } } });
            }
          })
        }else{
          setDisplayErrorMsg(data.payload.errormsg)
          setError([])
          setLoader(false)
        }
      }) 
    }else{
      setError(validate(validation_input))
      setDisplayErrorMsg(false)
    }  
  }

  return(
      <LoginContainer>
        {/* Display Image */}
        <Grid container>
          <Grid size={{ xs: 12, sm: 10, md: 10, lg:8 }} style={{display:'flex', justifyContent:"center"}}>
            <img src={SignInImage} alt="Login" style={{ width: 'auto', height: '100vh', objectFit: 'cover'}} />
          </Grid>

          {/* Employee Forget Password Details */}
          <Grid size={{ xs: 12, sm: 10, md: 10, lg:4 }} style={{background:'#F1F1F1', borderBottomRightRadius:'10px', borderTopRightRadius:'10px', height:'auto', maxWidth:'100%'}}>
              <LogoBox>
                <img src={image} width={172} height={165} alt="" style={{objectFit: 'cover'}}/>
              </LogoBox>
              
              <ForgotPasswordDetails>
                  <H1FormTitle sx={{color:ThemeColor.palette.BrandColor, mt:1}}>
                     Forgot Password ?
                  </H1FormTitle>
                  <H5FormLabel sx={{color:ThemeColor.palette.Primarytext1, mt:3}}>
                     Registered Email
                  </H5FormLabel>
                  <InputBox name='Email' value={Email} onChange={handleChangeForEmail} sx={{width:'100%', border:"1px solid #B0AEFF", borderRadius:'10px', p:0.1, mt:1, pl:1}} placeholder ="User Email"/>
                  <DisplayError error={error} fortagid='email'/> 
                  <Button
                      id="validate"
                      variant="contained"
                      disabled={loader}
                      onClick={submitRegisteredEmailAddress}
                      sx={{
                          color: '#FFFFFF',
                          backgroundColor: '#3107AA',
                          '&:hover': { backgroundColor: '#3107AA', color: '#FFFFFF' },
                          fontSize: '16px', 
                          fontWeight: '500',
                          borderRadius:"10px",
                          textTransform: 'none', 
                          width:'100%', height:'40px',
                          marginTop:'20px',
                          boxShadow:'0px 4px 6px #e1e1e1'
                      }}
                      >
                      {loader ? <CircularProgress size={20} color="inherit" /> : 'Submit'}
                  </Button>
                  {displayErrorMsg ? <small style={{color:'red'}}>{displayErrorMsg} </small>:'' }

                  <Link to='/' style={{textDecoration:'none'}} >
                    <H7TablePrimeContent display='flex' justifyContent='start' sx={{color:ThemeColor.palette.TableButton, mt:3,textAlign:'start'}}>
                      <LessThanIcon/> Back to Login
                    </H7TablePrimeContent>
                  </Link>
              </ForgotPasswordDetails> 
          </Grid>  
        </Grid>
      </LoginContainer>
  )}


export default ForgotPassword